import React from "react";
import { motion } from "framer-motion";
import { STATS } from "../lib/site";
import { useSite } from "../context/SiteContext";

const fmt = (n) => (n ? new Intl.NumberFormat("fr-FR").format(n) : null);

const CARD_INITIAL = { opacity: 0, y: 30 };
const CARD_ANIMATE = { opacity: 1, y: 0 };
const CARD_VIEWPORT = { once: true };

export const Stats = () => {
  const site = useSite();
  const s = site?.stats || {};
  const items = [
    { value: fmt(s.spotify_listeners) || STATS[0].value, label: STATS[0].label },
    { value: fmt(s.myturn_streams) || STATS[1].value, label: STATS[1].label },
    STATS[2],
  ];

  return (
    <section id="stats" data-testid="stats-section" className="border-b border-white/[0.06] bg-surface/30">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-white/[0.06]">
        {items.map((st, i) => (
          <motion.div
            key={st.label}
            initial={CARD_INITIAL}
            whileInView={CARD_ANIMATE}
            viewport={CARD_VIEWPORT}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            data-testid={`stat-${i}`}
            className="py-12 sm:py-16 flex flex-col items-center sm:items-start sm:px-10 first:sm:pl-0"
          >
            <span className="font-serif text-5xl md:text-6xl font-light gold-text leading-none">{st.value}</span>
            <span className="text-sm text-[#A3A3A3] tracking-wide mt-3 text-center sm:text-left">{st.label}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
